<div class="tile m-0 p-0 full-size" 
  [class.focused]="hasFocus"
  [attr.style]="iconBackgroundStyle" 
  [title]="window.title"
  (click)="windowClick()">
  <div *ngIf="!hasIcon" class="text-center text-{{theme.brightContrast}} flex-fill">
    <i class="fas fa-question-circle"></i>
  </div>
</div>